import { resetRequestState } from "../../utils/resetRequestState";
import { State } from "./types";

function handleEditList(state: State): State {
  return state.map((result) => ({
    ...result,
    request: resetRequestState(),
  }));
}

export { handleEditList };
